import { Component, computed, input } from '@angular/core';


const isNumber = (x: unknown): x is number => typeof x === 'number' && !isNaN(x);


@Component({
    selector: 'growth-arrow',
    styles: [
        `
        :host.fa-long-arrow-up {
            color: #32A41E;
        }
        :host.fa-long-arrow-down {
            color: #FF0E0E;
        }
        `
    ],
    host: {
        'class': 'fa',
        '[class.fa-long-arrow-up]': 'comparedValue() > 0',
        '[class.fa-long-arrow-down]': 'comparedValue() < 0',
    },
    template: ``,
})
export class GrowthArrowComponent<T> {

    current = input.required<T>();

    previous = input<T>();

    comparedValue = computed(() => {
        const current = this.current();
        const previous = this.previous();
        if (!isNumber(current) || !isNumber(previous)) {
            return NaN;
        }
        return Math.round((current - previous) * 100);
    });
}
